export const WALLET_PROVIDER_ID_PREFIX = 80_000_000_000_000;
export const PASSWORD_PROVIDER_ID_PREFIX = 81_000_000_000_000;
export const MAX_WALLET_NUMBER = 999_999_999;

export function isWalletPrincipalIdString(idStr: string | null | undefined): boolean {
  if (!idStr) return false;
  const n = Number(idStr);
  return (
    Number.isFinite(n) &&
    n >= WALLET_PROVIDER_ID_PREFIX &&
    n <= WALLET_PROVIDER_ID_PREFIX + MAX_WALLET_NUMBER
  );
}

export function isPasswordPrincipalIdString(idStr: string | null | undefined): boolean {
  if (!idStr) return false;
  const n = Number(idStr);
  return (
    Number.isFinite(n) &&
    n >= PASSWORD_PROVIDER_ID_PREFIX &&
    n <= PASSWORD_PROVIDER_ID_PREFIX + MAX_WALLET_NUMBER
  );
}

/** Wallet- or password-only synthetic id (not a real Telegram chat id). */
export function isSyntheticPrincipalIdString(idStr: string | null | undefined): boolean {
  return isWalletPrincipalIdString(idStr) || isPasswordPrincipalIdString(idStr);
}

export const PRINCIPAL_ID_STORAGE_KEY = 'jester_principal_id';
export const TELEGRAM_ID_STORAGE_KEY = 'jester_telegram_id';

/** Persist JWT principal + native Telegram id (never write synthetics as a Telegram id). */
export function persistAccountIdentity(userId: string, telegramId?: string | null): void {
  try {
    const principal = String(userId || '').trim();
    if (principal) localStorage.setItem(PRINCIPAL_ID_STORAGE_KEY, principal);
    const native = String(telegramId || '').trim();
    if (native && /^\d+$/.test(native) && !isSyntheticPrincipalIdString(native)) {
      localStorage.setItem(TELEGRAM_ID_STORAGE_KEY, native);
      return;
    }
    if (principal && !isSyntheticPrincipalIdString(principal)) {
      localStorage.setItem(TELEGRAM_ID_STORAGE_KEY, principal);
    }
  } catch {
    /* ignore */
  }
}

export function clearAccountIdentity(): void {
  try {
    localStorage.removeItem(PRINCIPAL_ID_STORAGE_KEY);
    localStorage.removeItem(TELEGRAM_ID_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Logged-in account id for client caches (principal, else Telegram id). */
export function readAccountPrincipalId(): string {
  try {
    const principal = String(localStorage.getItem(PRINCIPAL_ID_STORAGE_KEY) || '').trim();
    if (principal) return principal;
    return String(localStorage.getItem(TELEGRAM_ID_STORAGE_KEY) || '').trim();
  } catch {
    return '';
  }
}
